import React from 'react'
import Container from '@packages/justo-parts/lib/components/Container'
import {useTranslation} from 'next-i18next'

import SearchedItems from './SearchedItems'

import styles from '@page-components/Order/CategoriesLayout/Categories/Category/styles.module.css'

export interface Props {
  filter: string
  shouldHidePrice: boolean
}

export default function SearchResults(props: Props) {
  const {filter, shouldHidePrice} = props
  const {t} = useTranslation('generic', {keyPrefix: 'fields'})

  return (
    <div className={styles.mainContainer}>
      <Container>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.name}>{t('result')}</div>
          </div>
          <SearchedItems filter={filter} shouldHidePrice={shouldHidePrice} />
        </div>
      </Container>
    </div>
  )
}
